import { useTranslation } from 'react-i18next';
import React from 'react';
import {
  Col, Row, Typography,
} from 'antd';
import styled from 'styled-components';
import { geofencingAssetPropTypes } from '../../../types';
import { getCleanMoment } from '../../../utils/dateTimeUtils';
import { FlexRight } from '../../../components';
import { DEFAULT_DATE_TIME } from '../../../utils/constants/timeFormats';

const ArrivingTime = ({ geofencingData }) => {
  const { t } = useTranslation();
  const show = geofencingData !== {};

  const Time = styled.span`
    margin-left: 6px;
  `;

  const arrived = geofencingData && geofencingData.in
    ? getCleanMoment(geofencingData.in).format(DEFAULT_DATE_TIME)
    : null;

  const departed = geofencingData && geofencingData.out
    ? getCleanMoment(geofencingData.out).format(DEFAULT_DATE_TIME)
    : null;

  return show && (
    <Row justify="end" key={geofencingData.assetId} style={{ marginBottom: '8px' }}>
      <Col style={{ textAlign: 'right' }}>
        <FlexRight>
          <Typography.Text strong>
            {geofencingData.licensePlateNumber}
          </Typography.Text>
        </FlexRight>
        {arrived && (
          <FlexRight>
            <span style={{ whiteSpace: 'nowrap' }}>
              {t('ORDER.GEOFENCING_ARRIVED')}
              :
            </span>
            <Time>
              {arrived}
            </Time>
          </FlexRight>
        )}
        {departed && (
          <FlexRight>
            <span style={{ whiteSpace: 'nowrap' }}>
              {t('ORDER.GEOFENCING_DEPARTED')}
              :
            </span>
            <Time>
              {departed}
            </Time>
          </FlexRight>
        )}
      </Col>
    </Row>
  );
};

ArrivingTime.propTypes = {
  geofencingData: geofencingAssetPropTypes,
};

ArrivingTime.defaultProps = {
  geofencingData: {},
};

export default ArrivingTime;
